var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "dashboards-maker--button",
      class:
        ((_obj = {}),
        (_obj["dashboards-maker--button__" + _vm.template] = !!_vm.template),
        _obj)
    },
    [
      _vm.icon ? _c("i", { class: "fas fa-" + _vm.icon }) : _vm._e(),
      _vm._v(" "),
      _c("div", [_vm._t("default")], 2)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }